
import Vue from "vue";
import Component from "vue-class-component"; // 导入组件装饰器
import { getAuthorization } from "@/api/common";
import {
  formatDate,
  guid,
  getFileExtendingName,
  getYearMonthNow,
  getDateNow
} from "@/api/tools"; //导入相关工具
import { CompanyManageApi } from "@/api/companyManage"; //导入配套接口API
import {
  QueryForm,
  GetByPageData,
  GetByPageDataDetail,
  AddDataDetail
} from "@/models/companyManage/index"; //导入配套数据定义Model
@Component({
  components: {},
  filters: {
    //过滤器格式化时间
    myFormatDate: function(time) {
      let date = new Date(time);
      return formatDate(date, "yyyy-MM-dd hh:mm:ss");
    },
    //从路径中获取文件名
    getFileName: function(path) {
      var obj = path.lastIndexOf("/");
      return path.substr(obj + 1);
    }
  }
}) // Component装饰器装饰类
export default class CompanyManage extends Vue {
  // --------------------------------------------------------------数据区--------------------------------------------------------------
  name = "";
  tableloading = false;
  // rangeTime = "";
  // 新增、编辑Dialog
  isCreate = false;
  dialogVisible = false;
  dialogLoading = false;

  // 获取接口API
  companyManage: CompanyManageApi = new CompanyManageApi();
  // 列表数据-查询参数
  queryForm: QueryForm = new QueryForm();
  // 列表数据-查询结果数据格式
  getByPageData: GetByPageData = new GetByPageData();
  //列表数据-查询结果数据格式-数据部分
  getByPageDataDetail: GetByPageDataDetail = new GetByPageDataDetail();
  // 新增-查询结果数据格式-数据部分
  addDataDetail: AddDataDetail = new AddDataDetail();
  rules: any = {
    groceryCnName: [
      { required: true, message: "请输入中文名称", trigger: "blur" }
    ],
    groceryEnName: [
      { required: true, message: "请输入英文名称", trigger: "blur" }
    ]
  };

  // --------------------------------------------------------------方法区----------------------------------------------------------------
  // 生命周期钩子
  created() {
    this.queryForm.sortField = "createTime";
    this.onQuery(false);
  }
  //报告列表数据加载
  onQuery(isFlag: boolean = true) {
    this.tableloading = true;
    this.companyManage
      .getGroceryByPage(this.queryForm)
      .then((res: any) => {
        if (res.data) {
          this.getByPageData.tableData = res.data.data;
          this.getByPageData.total = res.data.total;
          if (isFlag) {
            this.$message({
              showClose: true,
              message: "查询成功",
              type: "success"
            });
          }
        } else {
          this.$message({
            showClose: true,
            message: "查询失败",
            type: "error"
          });
        }
        this.tableloading = false;
      })
      .catch(error => {
        this.tableloading = false;
      });
  }
  // 报告种类新增
  onAdd() {
    this.isCreate = true;
    this.addDataDetail = new AddDataDetail();
    this.dialogVisible = true;
  }
  // 编辑报告种类
  onEdit(row) {
    this.isCreate = false;
    this.addDataDetail.groceryEnName = row.groceryEnName;
    this.addDataDetail.groceryCnName = row.groceryCnName;
    this.addDataDetail.id = row.id;
    this.dialogVisible = true;
  }
  // 报告种类提交
  onSave() {
    (this.$refs.ReportListForm as any).validate(valid => {
      if (valid) {
        if (this.isCreate) {
          this.companyManage
            .insertGrocery(this.addDataDetail)
            .then((res: any) => {
              if (res.data) {
                this.$message({
                  showClose: true,
                  message: "新增成功",
                  type: "success"
                });
                this.dialogVisible = false;
                this.onQuery(false);
              } else {
                this.$message({
                  showClose: true,
                  message: "新增失败",
                  type: "error"
                });
              }
              this.dialogLoading = false;
            })
            .catch(error => {
              this.dialogLoading = false;
            });
        } else {
          this.companyManage
            .updateGrocery(this.addDataDetail)
            .then((res: any) => {
              if (res.data) {
                this.$message({
                  showClose: true,
                  message: "编辑成功",
                  type: "success"
                });
                this.dialogVisible = false;
                this.onQuery(false);
              } else {
                this.$message({
                  showClose: true,
                  message: "编辑失败",
                  type: "error"
                });
              }
              this.dialogLoading = false;
            })
            .catch(error => {
              this.dialogLoading = false;
            });
        }
      }
    });
  }
  // 零售商删除
  onDelete(row) {
    this.$confirm('此操作将删除该零售商, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      this.tableloading = true;
      this.companyManage
        .deleteGrocery({ id: row.id })
        .then((res: any) => {
          this.tableloading = false;
          if (res.data) {
            console.log("DeleteGrocery", res.data);
            this.$message({
              message: "删除成功",
              type: "success"
            });
            this.onQuery(false);
          } else {
            this.$message.error("删除失败");
          }
        })
        .catch(error => {
          this.tableloading = false;
        });
    })
  }
  //   // 日期选择时分解单个字串为beginCreateTime、endCreateTime
  //   onPickChange() {
  //     if (this.rangeTime != null && this.rangeTime.length > 0) {
  //       this.queryForm.beginTime = this.rangeTime[0];
  //       this.queryForm.endTime = this.rangeTime[1];
  //     } else {
  //       this.queryForm.beginTime = "";
  //       this.queryForm.endTime = "";
  //     }
  //   }
  //sortChange事件
  handelSortChange(column, prop, order) {
    console.log("handelSortChange  column, prop, order", column, prop, order);

    this.queryForm.sortField = column.prop;
    if (column.order == "descending") {
      this.queryForm.sortBy = 1;
    } else if (column.order == "ascending") {
      this.queryForm.sortBy = 0;
    } else {
      this.queryForm.sortBy = 0;
    }
    console.log(" this.queryForm", this.queryForm);
    this.onQuery(false);
  }
  // 报告列表分页页容量变化事件
  onPageSizeChange(val) {
    this.queryForm.pageSize = val;
    this.queryForm.currentPageIndex = 1;
    this.onQuery(false);
  }
  // 报告列表分页页码变化事件
  onPageIndexChange(val) {
    this.queryForm.currentPageIndex = val;
    this.onQuery(false);
  }
  //格式化日期
  formatDate(time) {
    if (time == "") {
      return "";
    }
    let date = new Date(time);
    return formatDate(date, "yyyy-MM-dd hh:mm:ss");
  }
}
